/**
 * AMP Slide Cart (SlideCart HQ) + EG Auto Add integration.
 * Keep Dawn cart-drawer for AJAX add-to-cart; never show Dawn UI.
 * Open SlideCart via SLIDECART_OPEN after add so EG can process gifts first.
 */
(function () {
  function tryOpenAmpCart() {
    try {
      if (typeof window.SLIDECART_OPEN === 'function') {
        window.SLIDECART_OPEN();
        return true;
      }
      if (typeof window.openSlideCart === 'function') {
        window.openSlideCart();
        return true;
      }
      if (window.SlideCartHQ && typeof window.SlideCartHQ.open === 'function') {
        window.SlideCartHQ.open();
        return true;
      }
      if (window.SLIDECART) {
        document.dispatchEvent(new CustomEvent('slidecart:open'));
        document.dispatchEvent(new CustomEvent('slide-cart:open'));
      }
      var toggle = document.querySelector(
        '#slidecart-toggle, .slidecart-toggle, [data-slidecart-open], a[href="#slidecart"]'
      );
      if (toggle && !toggle.closest('cart-drawer')) {
        toggle.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        return true;
      }
    } catch (e) {}
    return false;
  }

  function patchDrawer(drawer) {
    if (!drawer || drawer.dataset.aurAmpPatched === '1') return;
    drawer.dataset.aurAmpPatched = '1';

    drawer.open = function () {
      document.body.classList.remove('overflow-hidden');
      drawer.classList.remove('animate', 'active');
      var open = function () {
        setTimeout(tryOpenAmpCart, 150);
        setTimeout(tryOpenAmpCart, 700);
      };
      if (typeof window.AUR_SYNC_GIFTS === 'function') {
        window.AUR_SYNC_GIFTS().then(open).catch(open);
      } else {
        open();
      }
    };

    drawer.close = function () {
      document.body.classList.remove('overflow-hidden');
      drawer.classList.remove('animate', 'active');
    };

    var originalRender = drawer.renderContents && drawer.renderContents.bind(drawer);
    if (originalRender) {
      drawer.renderContents = function (parsedState) {
        try {
          originalRender(parsedState);
        } catch (e) {}
        drawer.classList.remove('animate', 'active');
        document.body.classList.remove('overflow-hidden');
        var open = function () {
          setTimeout(tryOpenAmpCart, 200);
          setTimeout(tryOpenAmpCart, 800);
        };
        if (typeof window.AUR_SYNC_GIFTS === 'function') {
          window.AUR_SYNC_GIFTS().then(open).catch(open);
        } else {
          open();
        }
      };
    }
  }

  function init() {
    document.querySelectorAll('cart-drawer').forEach(patchDrawer);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', function () {
    setTimeout(tryOpenAmpCart, 300);
  });
})();
